/* Affiorezuna · design × package photos
   Looks for photos uploaded under Content > Files, named <shape>-<NN>-<package>.jpg
   (e.g. heart-07-magnet.jpg, heart-07-card.jpg, heart-07-bag.jpg).
   A missing photo falls back to the magnet photo; a shape with no magnet photos yet
   (only card photos) shows its card photo instead. Otherwise the page keeps what it shows. */
(function () {
  var me = document.currentScript;
  var root = document.querySelector('[data-af-pdp]');
  if (!me || !root) return;

  var BASE = me.getAttribute('data-base') || '/cdn/shop/files/';
  var SHAPE = me.getAttribute('data-prefix') || 'heart';
  var EXTS = (me.getAttribute('data-ext') || 'jpg').split(',');
  // Bumped whenever the photos in Files are replaced, so browsers and the CDN fetch the new ones.
  var VER = me.getAttribute('data-version') || '';
  var stage = root.querySelector('[data-stage-img]');
  var designs = Array.prototype.slice.call(root.querySelectorAll('[data-design]'));
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cache = {};
  var ticket = 0;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function keyOf(value) {
    var v = (value || '').toLowerCase();
    if (v.indexOf('card') > -1) return 'card';
    if (v.indexOf('bag') > -1 || v.indexOf('organza') > -1 || v.indexOf('tulle') > -1) return 'bag';
    if (v.indexOf('box') > -1) return 'box';
    return 'magnet';
  }

  function load(src) {
    if (!cache[src]) {
      cache[src] = new Promise(function (done) {
        var img = new Image();
        img.onload = function () { done(src); };
        img.onerror = function () { done(null); };
        img.src = src;
      });
    }
    return cache[src];
  }

  // First existing file for this design and package, or null.
  function find(num, key, width) {
    return EXTS.reduce(function (chain, ext) {
      return chain.then(function (hit) {
        return hit || load(BASE + SHAPE + '-' + pad(num) + '-' + key + '.' + ext.trim() + '?width=' + width + (VER ? '&v=' + VER : ''));
      });
    }, Promise.resolve(null));
  }

  function numberOf(btn) { return designs.indexOf(btn) + 1; }
  function current() { return root.querySelector('[data-design][aria-pressed="true"]'); }
  function packKey() {
    var p = root.querySelector('[data-pack]:checked');
    return keyOf(p && p.value);
  }

  // The photo to use when a package has none yet: the magnet photo, or the card photo when the magnet one is missing.
  function fallbackKey(key) { return key === 'magnet' ? 'card' : 'magnet'; }

  // A design in a package, falling back to another package's photo when that package has no photo yet.
  function tileSrc(num, key) {
    return find(num, key, 480).then(function (src) {
      return src || find(num, fallbackKey(key), 480);
    });
  }

  /* Design tiles: show each design in the chosen package.
     A sample image picked in the theme editor always wins. */
  function fillTile(btn) {
    if (btn.querySelector('img:not([data-af-tile])')) return;
    var key = packKey();
    btn.__afKey = key;
    tileSrc(numberOf(btn), key).then(function (src) {
      if (!src || btn.__afKey !== key) return;
      var img = btn.querySelector('img[data-af-tile]');
      if (!img) {
        img = new Image();
        img.alt = '';
        img.decoding = 'async';
        img.setAttribute('data-af-tile', '');
        var ph = btn.querySelector('svg.placeholder-svg');
        if (ph) ph.parentNode.removeChild(ph);
        btn.insertBefore(img, btn.firstChild);
      }
      if (img.getAttribute('src') !== src) img.src = src;
      // The stage sample is the photo this tile shows; showStage then swaps in the chosen package's photo.
      if (!btn.getAttribute('data-sample')) {
        btn.setAttribute('data-sample', src.replace('width=480', 'width=1200'));
      }
    });
  }

  // Tiles already on screen switch to the chosen package; the rest pick it up when they scroll into view.
  function refreshTiles() {
    designs.forEach(function (btn) {
      if (btn.querySelector('img[data-af-tile]')) fillTile(btn);
    });
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.unobserve(e.target); fillTile(e.target); }
      });
    }, { rootMargin: '200px' });
    designs.forEach(function (b) { io.observe(b); });
  } else {
    designs.forEach(fillTile);
  }

  // On first load the big image shows the product's first photo, not a design.
  // The design preview takes over once the customer picks a design or package.
  var engaged = false;
  function photoMode() {
    var back = root.querySelector('[data-stage-back]');
    var badge = root.querySelector('[data-stage-badge]');
    if (back) back.hidden = true;
    if (badge) badge.hidden = true;
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.af-thumbs [data-media]'));
    var first = thumbs.filter(function (t) { return !t.hasAttribute('data-media-design'); })[0];
    thumbs.forEach(function (t) { t.setAttribute('aria-pressed', t === first ? 'true' : 'false'); });
    if (first && stage && first.getAttribute('data-media') && stage.getAttribute('src') !== first.getAttribute('data-media')) {
      stage.src = first.getAttribute('data-media');
      stage.alt = first.getAttribute('data-alt') || stage.alt;
    }
  }

  // Big image: the chosen design in the chosen package.
  function designMode() {
    var back = root.querySelector('[data-stage-back]');
    var badge = root.querySelector('[data-stage-badge]');
    if (back) back.hidden = true;
    if (badge) badge.hidden = false;
    Array.prototype.forEach.call(root.querySelectorAll('.af-thumbs [aria-pressed]'), function (t) {
      t.setAttribute('aria-pressed', t.hasAttribute('data-media-design') ? 'true' : 'false');
    });
  }

  function showStage() {
    var btn = current();
    if (!btn || !stage) return;
    var mine = ++ticket;
    var n = numberOf(btn);
    var key = packKey();
    find(n, key, 1200)
      .then(function (src) { return src || find(n, fallbackKey(key), 1200); })
      .then(function (src) {
        if (!src || mine !== ticket) return;
        designMode();
        stage.alt = btn.getAttribute('data-name') || '';
        if (stage.getAttribute('src') === src) return;
        stage.src = src;
        if (!still && stage.animate) stage.animate([{ opacity: 0.35 }, { opacity: 1 }], { duration: 240, easing: 'ease-out' });
      });
  }

  // Package cards: each card previews the chosen design in that package.
  function fillPacks() {
    var btn = current();
    if (!btn) return;
    var n = numberOf(btn);
    Array.prototype.forEach.call(root.querySelectorAll('[data-pack]'), function (input) {
      var card = input.closest('.af-pack');
      var box = card && card.querySelector('.af-choice__box');
      if (!box) return;
      find(n, keyOf(input.value), 320).then(function (src) {
        if (btn !== current()) return;
        var holder = box.querySelector('.af-pack__img');
        var img = holder && holder.querySelector('img');
        if (src) {
          if (!holder) {
            holder = document.createElement('span');
            holder.className = 'af-pack__img';
            holder.setAttribute('data-added', '');
            box.insertBefore(holder, box.firstChild);
          }
          if (!img) { img = new Image(); img.alt = ''; holder.appendChild(img); }
          if (!img.hasAttribute('data-orig')) {
            img.setAttribute('data-orig', img.getAttribute('src') || '');
            img.setAttribute('data-orig-set', img.getAttribute('srcset') || '');
          }
          img.removeAttribute('srcset');
          img.src = src;
          card.classList.remove('af-pack--noimg');
        } else if (holder && holder.hasAttribute('data-added')) {
          holder.parentNode.removeChild(holder);
          card.classList.add('af-pack--noimg');
        } else if (img && img.hasAttribute('data-orig')) {
          img.src = img.getAttribute('data-orig');
          if (img.getAttribute('data-orig-set')) img.setAttribute('srcset', img.getAttribute('data-orig-set'));
        }
      });
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-design], [data-stage-back], [data-media-design]');
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute('data-design')) fillPacks();
    // A design restored from a saved visit is selected, but the page still opens on the product photo.
    if (t.hasAttribute('data-design') && e.isTrusted === false && !engaged) return;
    engaged = true;
    showStage();
  });

  document.addEventListener('change', function (e) {
    if (!(e.target.matches && e.target.matches('[data-pack]') && root.contains(e.target))) return;
    // The design catalog always follows the chosen package, also when it is restored from a saved visit.
    refreshTiles();
    if (e.isTrusted === false && !engaged) return;
    engaged = true;
    showStage();
  });

  // Any real tap or click on the product area means the customer is browsing: never reset after that.
  ['click', 'change', 'input'].forEach(function (type) {
    root.addEventListener(type, function (e) { if (e.isTrusted) engaged = true; }, true);
  });

  function start() {
    if (!engaged) photoMode();
    fillPacks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  // A saved design restored after start-up must not replace the product photo either.
  window.addEventListener('load', function () { if (!engaged) photoMode(); });
})();
